export default __webpack_public_path__ + "static/media/solution_53.95e57abd.svg";